export namespace IncidentsConstants {
    export const BOUNDED_CONTEXT_NAME = 'Incidents';
    export const INCIDENT_MANAGEMENT_FEATURE = 'INCMAN';
    export const INCIDENTS_LIZENZ_MODUL = 'incidents';
    
}

